class ResetController {
	constructor(AuthFactory, $rootScope, $filter, $stateParams, ngDialog, $state){
		'ngInject';
		const vm = this;

		vm.rootScope = $rootScope;

		vm.$onInit = () =>{
			vm.password = null;
			vm.password_confirmation = null;
			vm.code = $stateParams.code;
		};

		vm.submit = () =>{
			AuthFactory.resetPassword(AuthFactory.USER_TYPES.TEAM, vm.code, vm.password, vm.password_confirmation)
					   .then(response =>{
						   ngDialog.open({template: 'successTemplate'});
						   $state.go('login');
					   });
		};
	}
}

export default ResetController;



// WEBPACK FOOTER //
// ./client/app/components/auth/reset/reset.controller.js